import { formatMoney } from "../../lib/meetupPricing";
import { MapPin } from "lucide-react";

export default function MeetupPinPeek({ pin, onDismiss }) {
  if (!pin) return null;

  return (
    <div
      className="absolute left-1/2 bottom-4 z-[4000] -translate-x-1/2 w-[min(92%,320px)] rounded-2xl border border-cyan-200/80 bg-white/95 backdrop-blur-md shadow-2xl px-4 py-3 animate-in fade-in slide-in-from-bottom-2 duration-200"
      role="status"
    >
      <div className="flex items-start gap-3">
        <div className="rounded-full bg-cyan-100 p-2 text-cyan-700 shrink-0">
          <MapPin className="w-4 h-4" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] uppercase tracking-wide text-cyan-600 font-semibold">Quick peek</p>
          <p className="font-semibold text-slate-900 truncate">{pin.name}</p>
          <p className="text-xs text-slate-500 truncate">
            {[pin.parish, pin.island].filter(Boolean).join(" · ")}
          </p>
          {pin.base_price_usd != null && (
            <p className="text-xs text-emerald-700 font-medium mt-1">
              from {formatMoney(pin.base_price_usd)}
            </p>
          )}
        </div>
        <button
          type="button"
          onClick={onDismiss}
          className="text-xs text-slate-400 hover:text-slate-600 shrink-0"
        >
          Tap for more
        </button>
      </div>
    </div>
  );
}
